'use client';
/** @jsxImportSource @emotion/react */

import type { SvgIconProps as MuiSvgIconProps } from '@mui/material/SvgIcon';

import MuiSvgIcon from '@mui/material/SvgIcon';

declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides {
    forceWhite: true;
  }
}

type ExcludedMuiProps =
  | 'component'
  | 'htmlColor'
  | 'inheritViewBox'
  | 'shapeRendering'
  | 'viewBox';

type SvgIconProps = Omit<MuiSvgIconProps, ExcludedMuiProps>;

export type { SvgIconProps };

export const SvgIcon: React.FC<SvgIconProps> = MuiSvgIcon;

SvgIcon.displayName = 'SvgIcon';
